module.exports = __webpack_public_path__ + "img/rolandjuno6.378ff902.jpg";